"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _themeContext["default"];
  }
});
Object.defineProperty(exports, "almostBlackColor", {
  enumerable: true,
  get: function get() {
    return _utils.almostBlackColor;
  }
});
Object.defineProperty(exports, "almostWhiteColor", {
  enumerable: true,
  get: function get() {
    return _utils.almostWhiteColor;
  }
});
Object.defineProperty(exports, "alternateColor", {
  enumerable: true,
  get: function get() {
    return _utils.alternateColor;
  }
});
Object.defineProperty(exports, "accessibleTextColor", {
  enumerable: true,
  get: function get() {
    return _utils.accessibleTextColor;
  }
});
Object.defineProperty(exports, "colorsAreAccessible", {
  enumerable: true,
  get: function get() {
    return _utils.colorsAreAccessible;
  }
});
Object.defineProperty(exports, "colorCanDarken", {
  enumerable: true,
  get: function get() {
    return _utils.colorCanDarken;
  }
});
Object.defineProperty(exports, "colorCanLighten", {
  enumerable: true,
  get: function get() {
    return _utils.colorCanLighten;
  }
});
Object.defineProperty(exports, "fadedColor", {
  enumerable: true,
  get: function get() {
    return _utils.fadedColor;
  }
});
Object.defineProperty(exports, "hslObject", {
  enumerable: true,
  get: function get() {
    return _utils.hslObject;
  }
});
Object.defineProperty(exports, "isColor", {
  enumerable: true,
  get: function get() {
    return _utils.isColor;
  }
});
Object.defineProperty(exports, "setLuminoscity", {
  enumerable: true,
  get: function get() {
    return _utils.setLuminoscity;
  }
});
Object.defineProperty(exports, "colorizeWithCSSFilter", {
  enumerable: true,
  get: function get() {
    return _utils.colorizeWithCSSFilter;
  }
});
exports.demoTheme = void 0;

var _themeContext = _interopRequireDefault(require("./themeContext"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var demoTheme = {
  color: {
    primary: '#902929',
    secondary: '#495896',
    danger: 'darkred',
    info: 'skyblue',
    success: 'lightgreen',
    warning: 'orange',
    background: '#F2F3F5',
    backgroundAlternate: '#666',
    text: '#333'
  },
  button: {
    allCaps: false,
    borderRadius: 20,
    fontWeight: 600
  },
  spinner: {
    color: '#495896'
  },
  checkbox: {
    borderRadius: 0,
    color: {
      unchecked: '#333',
      checked: '#495896'
    }
  },
  loader: {
    color: '#495896'
  }
};
exports.demoTheme = demoTheme;